import(/* webpackMode: "eager" */ "D:\\magichands-main\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager" */ "D:\\magichands-main\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\magichands-main\\src\\components\\AosAnimation.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\magichands-main\\src\\components\\BookAppointment\\BookAppointment.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\magichands-main\\src\\components\\CookieConsentBanner.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\magichands-main\\src\\components\\ModalPopup\\ModalPopup.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\magichands-main\\src\\components\\Navbar\\Navbar.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\magichands-main\\src\\components\\Preloader\\Preloader.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\magichands-main\\src\\components\\SpecialServiceDisplay.jsx");
